module.exports = __webpack_public_path__ + "img/CRTNJLS.3e4769ed.svg";